import { render, staticRenderFns } from "./ActiveStep.vue?vue&type=template&id=6faa4f87&"
import script from "./ActiveStep.vue?vue&type=script&lang=ts&"
export * from "./ActiveStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports